import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkCardSectionSeparatorType, UitkCardTextSegment } from "uitk-react-cards";
import TruncatedText from "shiitake";
import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { ReviewCountAndRating } from "./ReviewCountAndRating";

export const FeaturedReviewContent = ({
  hotel,
  context
}: {
  hotel: Hotel;
  context: ExtendedContextStore;
}) => {
  const { featuredReviews } = hotel;

  if (!featuredReviews || featuredReviews.length === 0) {
    return null;
  }

  return (
    <UitkCardTextSegment separator={UitkCardSectionSeparatorType.TOP}>
      <ReviewCountAndRating hotel={hotel} context={context} />
      {featuredReviews[0].title && (
        <div className="uitk-type-heading-300 all-b-margin-two">{featuredReviews[0].title}</div>
      )}
      <TruncatedText
        lines={3}
        renderFullOnServer={true}
        overflowNode={"\u2026\u0022"}
        className="truncatedReview uitk-type-paragraph-300"
        tagName="p"
      >
        {`\u0022${featuredReviews[0].review}\u0022`}
      </TruncatedText>
      <p className="uitk-type-paragraph-200">
        <LocalizedText message="hotels.review.reviewedOn" data={[featuredReviews[0].reviewDate]} />
      </p>
    </UitkCardTextSegment>
  );
};
